<template>
	<div>
		<div class="title">被保险人信息</div>
		<div class="mt15 mb16">
			<!-- 被保险人名称显示 -->
			<div v-if="info.insuredList && info.insuredList[0] && info.insuredList[0].subjectName" class="mt10">
				<div class="insured-name">
					<label>被保险人名称：</label>
					<span>{{ info.insuredList[0].subjectName }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		info: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
		}
	},
	methods: {
	}
}
</script>

<style scoped lang="less">
.insured-desc {
	background-color: #fff7e6;
	border: 1px solid #ffd591;
	border-radius: 4px;
	padding: 12px 16px;
	margin-top: 10px;
}

.desc-text {
	color: #d46b08;
	font-size: 14px;
	line-height: 1.5;
}


.title {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 15px;
}

.mt15 {
	margin-top: 15px;
}

.mb16 {
	margin-bottom: 16px;
}

.mt10 {
	margin-top: 10px;
}

.insured-name {
	background-color: #f6f8fa;
	border: 1px solid #d0d7de;
	border-radius: 4px;
	padding: 12px 16px;
	margin-top: 10px;
}

.insured-name label {
	font-weight: bold;
	color: #333;
	margin-right: 8px;
}

.insured-name span {
	color: #0969da;
	font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/InsuredPersonInfo.vue